import { AttachmentProvider } from "./AttachmentContext";
import AttachmentUploadButton from "./AttachmentUploadButton";
import AttachmentList from "./AttachmentList";
import AttachmentDeleteModal from "./AttachmentDeleteModal";

export default function TaskAttachments({ task, onTaskChange, descriptionEditorRef, newTask = false }) {
    return (
        <AttachmentProvider 
            task={task} 
            onTaskChange={onTaskChange} 
            descriptionEditorRef={descriptionEditorRef} 
            newTask={newTask}
        >
            {newTask ? (
                <div className="flex flex-col gap-2 w-full">
                    <div className="flex items-center gap-2 mb-1">
                        <AttachmentUploadButton />
                    </div>
                    <AttachmentList style="minimal" />
                </div>
            ) : (
                <>
                    {!task?.attachments?.length ? (
                        <div className="space-y-2">
                            <AttachmentUploadButton />
                        </div>
                    ) : (
                        <div className="space-y-2">
                            <div className="flex items-center justify-start gap-1">
                                <h3 className="font-medium">
                                    Attachments ({task.attachments.length})
                                </h3>
                                <div className="ml-3 mr-1.5 bg-border w-[1px] h-5" />
                                <AttachmentUploadButton />
                            </div>
                            <AttachmentList style="grid" />
                        </div>
                    )}
                </>
            )}
            <AttachmentDeleteModal />
        </AttachmentProvider>
    );
}

// Export the individual components for use elsewhere
export { AttachmentProvider, AttachmentUploadButton, AttachmentList, AttachmentDeleteModal };